import { SignInStore } from "app/spaceStone/signIn/signInStore";
import { LayoutStore } from "app/layout/store";
import { MyDepositStore } from "app/timeStone/properties/releaseRequests/store/myDepositStore";
import { LocalizationStore } from "localization/localizationStore";
import { computed, makeObservable, observable } from "mobx";
import { RouterStore } from "mobx-react-router";
import { AuthStore } from "shared/store/authStore";
import { SignUpStore } from "app/spaceStone/signUp/store";
import { MyProfileStore } from "app/spaceStone/myProfile/store";
import { AccountType } from "shared/constants/enums";
import { getAccountTypeId } from "shared/utils/jwt.utils";
import routeNames from "shared/routes/constants/routeNames";
import { AppSettingsStore } from "shared/store/appSettingsStore";
import { AppNotificationsStore } from "shared/store/appNotificationsStore";

export class RootStore {
    @observable public routerStore: RouterStore;
    @observable public authStore: AuthStore;
    @observable public signInStore: SignInStore;
    @observable public signUpStore: SignUpStore;
    @observable public localizationStore: LocalizationStore;
    @observable public myProfileStore: MyProfileStore;
    @observable public layoutStore: LayoutStore;
    @observable public myDepositStore: MyDepositStore;
    @observable public appSettingsStore: AppSettingsStore;
    @observable public appNotificationsStore: AppNotificationsStore;
    @observable private accountTypeId: AccountType = AccountType.None;
    @observable private accountTypeIds = "";

    constructor() {
        makeObservable(this);
        this.routerStore = new RouterStore();
        this.authStore = new AuthStore(this);
        this.signInStore = new SignInStore(this);
        this.signUpStore = new SignUpStore(this);
        this.localizationStore = new LocalizationStore();
        this.myProfileStore = new MyProfileStore(this);
        this.myDepositStore = new MyDepositStore();
        this.layoutStore = new LayoutStore();
        this.appSettingsStore = new AppSettingsStore(this);
        this.appNotificationsStore = new AppNotificationsStore(this);
    }

    set setAccountTypeIds(accountTypeIds: string) {
        this.accountTypeIds = accountTypeIds;
        this.accountTypeId = getAccountTypeId(accountTypeIds);
    }

    set setAccountTypeId(roleID: AccountType) {
        this.accountTypeId = roleID;
    }

    @computed get getAccountTypeId(): AccountType {
        return this.accountTypeId;
    }

    @computed get isAdmin(): boolean {
        return this.accountTypeId && this.accountTypeId === AccountType.Admin;
    }

    @computed get isTenant(): boolean {
        return this.accountTypeId && this.accountTypeId === AccountType.Tenant;
    }

    @computed get isAgent(): boolean {
        return this.accountTypeId === AccountType.Agent;
    }

    @computed get isCorporateLandlord(): boolean {
        return this.accountTypeId && this.accountTypeId === AccountType.CorporateLandlord;
    }

    @computed get isPrivateLandlord(): boolean {
        return this.accountTypeId && this.accountTypeId === AccountType.PrivateLandlord;
    }

    @computed get isLandlord(): boolean {
        return (
            this.accountTypeId &&
            (this.accountTypeId === AccountType.CorporateLandlord || this.accountTypeId === AccountType.PrivateLandlord)
        );
    }

    @computed get isTenantIncluded(): boolean {
        return this.accountTypeIds.includes(AccountType.Tenant.toString());
    }

    @computed get isCompanyUser(): boolean {
        return (
            this.accountTypeIds.includes(AccountType.CorporateLandlord.toString()) ||
            this.accountTypeIds.includes(AccountType.Agent.toString())
        );
    }

    @computed get userHomeRoute(): string {
        if (this.isTenant) {
            return routeNames.TENANT_HOME.HOME;
        }

        return routeNames.DASHBOARD;
    }
}
